<template>
  <div>
    <div v-if="doShowLogin">
      <login-dialog :visible="showing" />
    </div>
  </div>
</template>

<script>
// this is just to ensure auth isn't loaded unless needed
export default {
  components: {
    LoginDialog: () => import(/* webpackChunkName: "auth" */ '@/components/dialogs/SignInDialog.vue'),
  },
  data () {
    return {
      doShowLogin: false,
      showing: false
    }
  },
  methods: {
    async handleReveal () {
      await this.$k.waitfor(200)
      this.showing = true
    }
  },
  watch: {
    '$store.state.loginDialog.show': function () {
      if(this.$store.state.loginDialog.show){
        this.doShowLogin = true
        this.handleReveal()
      }
      else {
        this.showing = false
      }
    }
  }
}
</script>

<style>

</style>